export interface BirthNumberItem {
  number: number;
  title: string;
  shortTitle: string;
  color: string;
  bgGradient: string;
}

const NUMBER_PALETTE = [
  {color: '#e53935', bgGradient: 'linear-gradient(135deg, #ef5350 0%, #c62828 100%)'},
  {color: '#fb8c00', bgGradient: 'linear-gradient(135deg, #ffa726 0%, #ef6c00 100%)'},
  {color: '#fdd835', bgGradient: 'linear-gradient(135deg, #ffee58 0%, #fbc02d 100%)'},
  {color: '#43a047', bgGradient: 'linear-gradient(135deg, #66bb6a 0%, #2e7d32 100%)'},
  {color: '#00acc1', bgGradient: 'linear-gradient(135deg, #26c6da 0%, #00838f 100%)'},
  {color: '#1e88e5', bgGradient: 'linear-gradient(135deg, #42a5f5 0%, #1565c0 100%)'},
  {color: '#5e35b1', bgGradient: 'linear-gradient(135deg, #7e57c2 0%, #4527a0 100%)'},
  {color: '#8e24aa', bgGradient: 'linear-gradient(135deg, #ab47bc 0%, #6a1b9a 100%)'},
  {color: '#d81b60', bgGradient: 'linear-gradient(135deg, #ec407a 0%, #ad1457 100%)'},
  {color: '#00897b', bgGradient: 'linear-gradient(135deg, #26a69a 0%, #00695c 100%)'},
];

export const BIRTH_NUMBERS: BirthNumberItem[] = Array.from({length: 31}, (_, i) => {
  const num = i + 1;
  const palette = NUMBER_PALETTE[(num - 1) % NUMBER_PALETTE.length];
  return {
    number: num,
    title: `${num}-е число`,
    shortTitle: `${num}`,
    color: palette.color,
    bgGradient: palette.bgGradient
  };
});

export function getBirthNumberItem(num: number | string): BirthNumberItem | undefined {
  const parsed = typeof num === 'string' ? parseInt(num, 10) : num;
  if (isNaN(parsed) || parsed < 1 || parsed > 31) return undefined;
  return BIRTH_NUMBERS[parsed - 1];
}

export function getBirthNumberTitle(num: number | string): string {
  const item = getBirthNumberItem(num);
  return item ? item.title : `${num}`;
}

export function extractDayFromDate(dateStr: string | null | undefined): number | null {
  if (!dateStr) return null;
  const match = dateStr.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})/);
  if (match) {
    const day = parseInt(match[1], 10);
    if (day >= 1 && day <= 31) return day;
  }
  return null;
}
